export default __webpack_public_path__ + "static/media/mobility_description.1314dd00.svg";